// Les pastilles au-dessus d'une liste : « Tous · 70 », « Brouillon · 4 »…
//
// Un clic filtre, un second clic sur la même pastille revient à « Tous ». Un
// chiffre par pastille : on voit d'un coup d'œil où sont les lignes, sans rien
// taper.

import type { CompteStatut } from '@imp/shared/liste-triee';

import { cn } from '@/lib/utils';

export function PastillesStatut({
  comptes,
  libelles,
  classes,
  actif,
  total,
  onChoisir,
  libelleTous = 'Tous',
}: {
  comptes: readonly CompteStatut[];
  libelles: Readonly<Record<string, string>>;
  /** La teinte de chaque statut, la même que dans la liste. */
  classes: Readonly<Record<string, string>>;
  actif: string | null;
  total: number;
  onChoisir: (statut: string | null) => void;
  libelleTous?: string;
}) {
  // Un statut demandé par l'adresse mais vide aujourd'hui reste visible, à 0 :
  // sinon on ne verrait ni pourquoi la liste est vide, ni comment en sortir.
  const affiches =
    actif !== null && !comptes.some((c) => c.statut === actif)
      ? [...comptes, { statut: actif, nombre: 0 }]
      : comptes;

  const pastille = (cle: string | null, libelle: string, nombre: number, teinte: string) => {
    const choisie = actif === cle;
    return (
      <button
        key={cle ?? '__tous'}
        type="button"
        aria-pressed={choisie}
        onClick={() => {
          onChoisir(choisie || cle === null ? null : cle);
        }}
        className={cn(
          'inline-flex min-h-9 items-center gap-1.5 rounded-full border px-3 text-sm font-medium transition-colors',
          choisie ? 'ring-primary border-transparent ring-2' : 'hover:bg-muted/60',
          teinte,
        )}
      >
        {libelle}
        <span className="tabular-nums opacity-70">{nombre}</span>
      </button>
    );
  };

  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Filtrer par statut">
      {pastille(null, libelleTous, total, 'bg-card')}
      {affiches.map((c) =>
        pastille(
          c.statut,
          libelles[c.statut] ?? c.statut,
          c.nombre,
          classes[c.statut] ?? 'bg-muted text-muted-foreground',
        ),
      )}
    </div>
  );
}
